import React from 'react';
import Icon from '../../../components/AppIcon';

const RoleSelector = ({ roles, selectedRole, onSelect }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      {roles?.map((role) => (
        <button
          key={role?.value}
          onClick={() => onSelect(role?.value)}
          className={`p-4 rounded-lg border-2 transition-all text-left ${
            selectedRole === role?.value
              ? 'border-primary bg-primary/5' :'border-border hover:border-primary/50 bg-card'
          }`}
        >
          <div className="flex items-center gap-3">
            <div
              className={`p-2 rounded-lg ${
                selectedRole === role?.value
                  ? 'bg-primary text-white' :'bg-muted text-foreground'
              }`}
            >
              <Icon name={role?.icon} size={18} />
            </div>
            <div className="flex-1">
              <div className="font-semibold text-foreground text-sm mb-1">
                {role?.label}
              </div>
              <div className="text-xs text-muted-foreground">
                {role?.description}
              </div>
            </div>
          </div>
        </button>
      ))}
    </div>
  );
};

export default RoleSelector;